import * as actionTypes from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { Signee, SigneesList } from '../../domain/Signee';
import { ListResults } from '../../common/List/List';
import { TaskDocument } from '../../domain/TaskDocument';

export const fetchSigneesStart = () => ({
  type: actionTypes.FETCH_SIGNEES_START,
});

export const fetchSigneesSuccess = (signeesList: SigneesList) => ({
  type: actionTypes.FETCH_SIGNEES_SUCCESS,
  signeesList,
});

export const fetchSigneesFail = (signeesError: HttpError) => ({
  type: actionTypes.FETCH_SIGNEES_FAIL,
  signeesError,
});

export const fetchSigneeDocumentsStart = () => ({
  type: actionTypes.FETCH_SIGNEE_DOCUMENTS_START,
});

export const fetchSigneeDocumentsSuccess = (
  signeeDocuments: ListResults<TaskDocument>,
) => ({
  type: actionTypes.FETCH_SIGNEE_DOCUMENTS_SUCCESS,
  signeeDocuments,
});

export const fetchSigneeDocumentsFail = (signeeDocumentsError: HttpError) => ({
  type: actionTypes.FETCH_SIGNEE_DOCUMENTS_FAIL,
  signeeDocumentsError,
});

export const fetchSigneeStart = () => ({
  type: actionTypes.FETCH_SIGNEE_START,
});

export const fetchSigneeSuccess = (signee: Signee) => ({
  type: actionTypes.FETCH_SIGNEE_SUCCESS,
  signee,
});

export const fetchSigneeFail = (signeeError: HttpError) => ({
  type: actionTypes.FETCH_SIGNEE_FAIL,
  signeeError,
});

export const createSigneeStart = () => ({
  type: actionTypes.CREATE_SIGNEE_START,
});

export const createSigneeSuccess = (createdSignee: Signee) => ({
  type: actionTypes.CREATE_SIGNEE_SUCCESS,
  createdSignee,
});

export const createSigneeFail = (signeeCreateError: HttpError) => ({
  type: actionTypes.CREATE_SIGNEE_FAIL,
  signeeCreateError,
});

export const updateSigneeStart = () => ({
  type: actionTypes.UPDATE_SIGNEE_START,
});

export const updateSigneeSuccess = () => ({
  type: actionTypes.UPDATE_SIGNEE_SUCCESS,
});

export const updateSigneeFail = (signeeUpdateError: HttpError) => ({
  type: actionTypes.UPDATE_SIGNEE_FAIL,
  signeeUpdateError,
});

export const deleteSigneeStart = () => ({
  type: actionTypes.DELETE_SIGNEE_START,
});

export const deleteSigneeSuccess = () => ({
  type: actionTypes.DELETE_SIGNEE_SUCCESS,
});

export const deleteSigneeFail = (signeeDeleteError: HttpError) => ({
  type: actionTypes.DELETE_SIGNEE_FAIL,
  signeeDeleteError,
});

export const toggleSigneeStatusStart = () => ({
  type: actionTypes.TOGGLE_SIGNEE_STATUS_START,
});

export const toggleSigneeStatusSuccess = () => ({
  type: actionTypes.TOGGLE_SIGNEE_STATUS_SUCCESS,
});

export const toggleSigneeStatusFail = (toggleSigneeStatusError: HttpError) => ({
  type: actionTypes.TOGGLE_SIGNEE_STATUS_FAIL,
  toggleSigneeStatusError,
});

export const signeeResendInvitationCodeStart = () => ({
  type: actionTypes.SIGNEE_RESEND_INVITATION_CODE_START,
});

export const signeeResendInvitationCodeSuccess = () => ({
  type: actionTypes.SIGNEE_RESEND_INVITATION_CODE_SUCCESS,
});

export const signeeResendInvitationCodeFail = (
  signeeResendInvitationCodeError: HttpError,
) => ({
  type: actionTypes.SIGNEE_RESEND_INVITATION_CODE_FAIL,
  signeeResendInvitationCodeError,
});

export const resetSigneeResendInvitationCodeStore = () => ({
  type: actionTypes.RESET_SIGNEE_RESEND_INVITATION_CODE_STORE,
});

export const resetCreatedSignee = () => ({
  type: actionTypes.RESET_CREATED_SIGNEE,
});

export const resetSigneeStore = () => ({
  type: actionTypes.RESET_SIGNEE_STORE,
});
